import County from './County.model';

export default class ServiceArea {
  internal_name: string;
  counties: Array<County>;
}
